var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeadVue',{on:{"loaded":_vm.headLoaded}}),(_vm.isHeadLoaded)?_c('router-view'):_vm._e(),(_vm.isHeadLoaded)?_c('FooterVue',{attrs:{"address":_vm.address,"siteID":_vm.siteID,"siteName":_vm.siteName,"company":_vm.company}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }